import { jsx as _jsx } from "react/jsx-runtime";
import UIComponent from './uiComponent';
import { resovleContent } from './utils';
import { Collapse } from 'antd';
import { useEffect, useState } from 'react';
import { makeStyles } from '@fluentui/react-components';
import UITheme from './uiTheme';
const useStyles = makeStyles({
    root: {
        '& .ant-collapse-header': {
            backgroundColor: '#002945',
            color: '#fff !important',
        },
    },
});
const UIScrollerComponent = ({ children, title, isEnabled, selectedPanel, panelOrder }) => {
    const initialActive = isEnabled && selectedPanel === panelOrder;
    const [activeKey, setActiveKey] = useState(initialActive ? [panelOrder] : []);
    const styles = useStyles();
    useEffect(() => {
        if (isEnabled && selectedPanel === panelOrder) {
            setActiveKey([panelOrder]);
        }
        else {
            setActiveKey([]);
        }
    }, [isEnabled, selectedPanel, panelOrder]);
    const handleCollapseChange = (key) => {
        if (!isEnabled)
            return;
        if (typeof key === 'string') {
            setActiveKey([Number(key)]);
        }
        else {
            setActiveKey(key.length > 0 ? [Number(key[0])] : []);
        }
    };
    return (_jsx(Collapse, { activeKey: activeKey, onChange: handleCollapseChange, className: `panel-${panelOrder}`, children: _jsx(Collapse.Panel, { className: selectedPanel === panelOrder ? styles.root : '', header: title, collapsible: isEnabled ? 'header' : 'disabled', children: children }, panelOrder) }));
};
export default class UIScroller extends UIComponent {
    title;
    isEnabled;
    panelOrder;
    selectedPanel;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        resovleContent(this, s);
        this.isEnabled = true;
        this.panelOrder = 1;
        this.selectedPanel = 1;
    }
    getComponent() {
        const children = this.children.map((c) => {
            return c.getComponent();
        });
        const props = { title: this.title, isEnabled: this.isEnabled, panelOrder: this.panelOrder, selectedPanel: this.selectedPanel };
        return (_jsx(UITheme, { children: _jsx(UIScrollerComponent, { ...props, children: children }) }));
    }
}
//# sourceMappingURL=uiScroller.js.map